export interface WorkplaceConfig {
  cnes: string;
  local_name: string;
  city: string;
  state: string;
  address: string;
  phone: string;
}

/**
 * Roteamento Inteligente de Estabelecimento (setWorkplace da MeMed):
 * Alterna dinamicamente os dados do carimbo/CNES entre atendimentos de Telemedicina
 * e atendimentos presenciais Domiciliares (Home Care).
 */
export function obterWorkplaceParaAtendimento(
  tipoAtendimento: 'TELEMEDICINA' | 'HOME_CARE' | string = 'TELEMEDICINA',
  dadosUnidadeLocal?: Partial<WorkplaceConfig>,
): WorkplaceConfig {
  const isHomeCare = String(tipoAtendimento).toUpperCase() === 'HOME_CARE';

  if (isHomeCare) {
    return {
      cnes:
        dadosUnidadeLocal?.cnes ||
        (typeof import.meta !== 'undefined' && (import.meta as any).env?.VITE_MEDIKEI_HOMECARE_CNES) ||
        '2001928',
      local_name: dadosUnidadeLocal?.local_name || 'Medikei Saúde - Atendimento Domiciliar',
      city: dadosUnidadeLocal?.city || 'São Paulo',
      state: dadosUnidadeLocal?.state || 'SP',
      address: dadosUnidadeLocal?.address || 'Atendimento em Domicílio (Home Care)',
      phone: dadosUnidadeLocal?.phone || '11999999999',
    };
  }

  // Atendimento padrão: Telemedicina Central
  return {
    cnes:
      (typeof import.meta !== 'undefined' && (import.meta as any).env?.VITE_MEDIKEI_TELEMED_CNES) ||
      '0000000',
    local_name: 'Medikei Saúde - Telemedicina Central',
    city: 'São Paulo',
    state: 'SP',
    address: 'Plataforma Digital de Telemedicina Medikei',
    phone: '11999999999',
  };
}
